import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { SettingsStateService } from './settings.state-service';
import { SideBarMenuService } from './side-bar-menu.service';
import { ReferenceDataService } from './reference-data.service';
import { AdminUiSettings, ProductType } from '../dtos';
import { AbcBootstrapService } from '../../modules/abc/abc-bootstrap.service';
import { CavexBootstrapService } from '../../modules/cavex/cavex-bootstrap.service';
import { PaygBootstrapService } from '../../modules/payg/payg-bootstrap.service';
import { SkootBootstrapService } from '../../modules/skoot/skoot-bootstrap.service';
import { FinanceBootstrapService } from '../../modules/finance/finance-bootstrap.service';
import { paymentSimulatorMenuItem } from '../../ui/side-nav/core-menu-items';

export interface IProductBootstrapService {
  initializeForProduct(settings: AdminUiSettings): void;
}

@Injectable({
  providedIn: 'root',
})
export class ProductBootstrapService implements IProductBootstrapService {
  constructor(
    private readonly settingsStateService: SettingsStateService,
    private readonly sideBarMenuService: SideBarMenuService,
    private readonly referenceDataService: ReferenceDataService,
    private readonly abcBootstrapService: AbcBootstrapService,
    private readonly cavexBootstrapService: CavexBootstrapService,
    private readonly paygBootstrapService: PaygBootstrapService,
    private readonly skootBootstrapService: SkootBootstrapService,
    private readonly financeBootstrapService: FinanceBootstrapService,

  ) {}

  initializeForProduct(): void {
    this.settingsStateService.settings$.subscribe((settings) => {
      const productBootstrapService = this.getProductBootstrapService(settings);
      productBootstrapService?.initializeForProduct(settings);
      this.registerDevToolsMenuItem();
    });
  }

  private registerDevToolsMenuItem(): void {
    this.referenceDataService.configSettings$
      .pipe(take(1))
      .subscribe((configSettings) => {
        if (configSettings.testToolsEnabled) {
          this.sideBarMenuService.appendMenuItem(paymentSimulatorMenuItem);
        }
      });
  }

  private getProductBootstrapService(
    settings: AdminUiSettings
  ): IProductBootstrapService | null {
    switch (settings.productType) {
      case ProductType.ABC:
        return this.abcBootstrapService;
      case ProductType.Cavex:
        return this.cavexBootstrapService;
      case ProductType.Skoot:
        return this.skootBootstrapService;
      case ProductType.PAYG:
        return this.paygBootstrapService;
      case ProductType.Financing:
        return this.financeBootstrapService;
      default:
        return null;
    }
  }
}
